module.exports = __webpack_public_path__ + "img/default.429eb60.png";